import React from 'react';

const CookiePolicy = () => {
  return (
    <section className="cookie-policy-container" style={{ backgroundColor: 'var(--black)', color: 'var(--text-light)', padding: '2rem', textAlign: 'center' }}>
      <h1 style={{ color: 'var(--gold)' }}>Cookie Policy</h1>
      <p>BankSystem keeps things simple—we don't use cookies to track or spy on you, as we're blockchain-based and text-only. This policy explains our minimal use in plain words, compliant with US laws like CCPA (no sale of data).</p>
      <h2 style={{ color: 'var(--gold)' }}>What Cookies We Use</h2>
      <p>Only essentials for basics like session management (e.g., wallet connect via omnipass.eth) or security. No ad trackers, no third-party stuff—just local storage for your ENS ID (alice.banksystem.eth) to remember logins. No personal data stored.</p>
      <h2 style={{ color: 'var(--gold)' }}>Why We Use Them</h2>
      <p>To make the platform work smoothly—remember your preferences for AI bots or low-fee trades (0.05%). We don't share with anyone, and it's all on your device.</p>
      <h2 style={{ color: 'var(--gold)' }}>Your Choices</h2>
      <p>Block cookies in your browser, but some features (like wallet mocks) might not work. Under CCPA, you can opt out (but we don't "sell" anyway). Questions? X community.</p>
      <p>Updates: Check back. Last: August 2025.</p>
    </section>
  );
};

export default CookiePolicy;
